<template>
  <!-- Navbar -->
  <nav
      id="main-header"
      class="main-header navbar navbar-expand"
      :class="navbarVariant"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <button class="nav-link" role="button" @click="onToggleMenuSidebar">
          <i class="fas fa-bars"></i>
        </button>
      </li>
    </ul>
    <div class="row">
    </div>

    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <div v-if="this.isDebugEnabled">
          <button class="btn btn-outline-neutral" @click="onToggleDebugTools">
            <i class="nav-icon fas fa-cogs" v-bind:style="{ color: this.isShowDebugTools ? 'blue': '' }"></i>
          </button>
        </div>
      </li>
      <user-dropdown></user-dropdown>
    </ul>
  </nav>
</template>

<script>
import Languages from './languages/languages.vue';
import User from './user/user.vue';
import {mapGetters} from "vuex";
import * as moment from "moment";

export default {
  components: {
    'languages-dropdown': Languages,
    'user-dropdown': User
  },
  data() {
    return {
      headerElement: null,
    }
  },
  async mounted() {
    this.headerElement = document.getElementById('main-header');
  },
  methods: {
    onToggleDebugTools() {
      this.$store.dispatch('toggleDebugTools')
    },
    onToggleMenuSidebar() {
      this.$store.dispatch('ui/toggleMenuSidebar');
    },
    onToggleControlSidebar() {
      this.$store.dispatch('ui/toggleControlSidebar');
    },
    updateTime() {
      this.serverTime = moment().tz('UTC').format('YYYY-MM-DD HH:mm:ss');
      this.localTime = moment().format('YYYY-MM-DD HH:mm:ss');
    },
  },
  computed: {
    ...mapGetters([
        'isDebugEnabled',
        'isShowDebugTools',
    ]),
    darkModeSelected() {
      return this.$store.getters['ui/darkModeSelected'];
    },
    navbarVariant() {
      return this.$store.getters['ui/navbarVariant'];
    },
    user() {
      return this.$store.getters['currentUser'];
    },
  }
}

</script>
<style></style>
